export default __webpack_public_path__ + "static/zt-leader-fca8fe1f3a08932fcda74fb79453d72a.png";